import { Link, NavLink } from 'react-router-dom';
import { useAuth } from '../auth';

export function Header() {
  const { user, logout } = useAuth();
  return (
    <header className="header">
      <div className="row" style={{ gap: 0 }}>
        <h1>
          <Link to="/users" style={{ color: 'inherit' }}>
            Piso Advisor · Backoffice
          </Link>
        </h1>
        <nav>
          <NavLink to="/users" className={({ isActive }) => (isActive ? 'active' : '')}>
            Usuarios
          </NavLink>
          <NavLink to="/purchases" className={({ isActive }) => (isActive ? 'active' : '')}>
            Compras
          </NavLink>
          <NavLink to="/config" className={({ isActive }) => (isActive ? 'active' : '')}>
            Configuración
          </NavLink>
          <NavLink to="/mockups" className={({ isActive }) => (isActive ? 'active' : '')}>
            Mockups
          </NavLink>
          <NavLink to="/feedback" className={({ isActive }) => (isActive ? 'active' : '')}>
            Feedback
          </NavLink>
          <NavLink to="/deployments" className={({ isActive }) => (isActive ? 'active' : '')}>
            Deployments
          </NavLink>
        </nav>
      </div>
      <div className="who">
        <span>{user?.email}</span>
        <button onClick={logout}>Cerrar sesión</button>
      </div>
    </header>
  );
}
